import { MatSort, MatSortHeader } from '@angular/material/sort';
import {ParamMap} from '@angular/router';

export class TableUtils {
    // Sets the Angular Material Sort header in the table programmatically by manually
    // toggling the animation state. Workaround until it's fixed.
    static setSortColumn(matSort: MatSort, column: string) {
        if (matSort && column) {
            const header = (matSort.sortables.get(column) as MatSortHeader);
            if (header) header._setAnimationTransitionState({toState: 'active'});
        }
    }

    static prepareForApiParams(params) {
        let {column, sortOrder, start, length, search} = params;
        if (sortOrder) {
            sortOrder = sortOrder === 'desc' ? -1 : 1;
        }
        let queryParams: any = params;
        if (start && length) {
            queryParams = {
                ...queryParams,
                start: start.toString(),
                length: length.toString()
            };
        }
        delete queryParams.sortOrder;
        if (column && sortOrder != null) {
            queryParams.column = column;
            queryParams.order = sortOrder;
        }
        if (search) {
            queryParams.search = search;
        }
        return queryParams;
    }

    static parseParams(params: ParamMap, defaultPage = 0, defaultLength = 25, defaultColumn?: string, defaultSortOrder?: any) {
        const start = parseInt(params.get('start') || defaultPage.toString(), 10);
        const length = parseInt(params.get('length') || defaultLength.toString(), 10);
        const column = params.get('column') || defaultColumn;
        const sortOrder = params.get('sortOrder') as any || defaultSortOrder;
        const search = params.get('search');
        const type = params.get('type');
        const status = params.get('status');
        const payedBy = params.get('payedBy');
        const maxHoursBefore = params.get('maxHoursBefore');
        const byUserType = params.get('byUserType');

        return Object.assign({},
            start == null ? null : {start},
            length == null ? null : {length},
            column && {column},
            sortOrder && {sortOrder},
            search && {search},
            type && {type},
            status && {status},
            payedBy && {payedBy},
            maxHoursBefore && {maxHoursBefore},
            byUserType && {byUserType},
        );
    }
}
